module.exports = __webpack_public_path__ + "img/jordi_adame.6cdac034.png";